import { useSearchParams } from '#pplx/frontend/router/useSearchParams.js';
export const IMMERSIVE_PARAM = 'immersive';
export const useImmersiveParam = () => {
    const searchParams = useSearchParams();
    return searchParams.get(IMMERSIVE_PARAM) === 'true';
};
//# sourceMappingURL=immersive.js.map